import React, { Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as VouchersActions } from 'store/ducks/vouchers';

import { Validate } from 'common';
import { Page, Breadcrumbs } from 'components';
import { Form } from 'pages/Points/Vouchers/components';

class Create extends Component {
  state = {
    data: {
      title: '',
      value: '',
      discount: '',
      days_to_expire: '',
      active: false,
      plan_ids: [],
    },
    errors: {},
    breadcrumbs: [
      { name: 'Home', to: '/' },
      { name: 'Pontos', to: '/points' },
      { name: 'Vouchers', to: '/points/vouchers' },
      { name: 'Novo', to: '' },
    ],
  };

  handleChange = data => {
    const { errors } = this.state;

    this.setState({ data });

    Object.keys(errors).length && this.handleValidate();
  };

  handleValidate = () => {
    const { data } = this.state;

    const rules = {
      title: {
        required: true
      },

      value: {
        required: true
      },

      discount: {
        required: true
      },

      days_to_expire: {
        required: true
      }
    };

    const validate = Validate(data, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleSave = () => {
    if (!this.handleValidate()) return;

    const { data } = this.state;
    const { createVoucherRequest } = this.props;

    createVoucherRequest({
      title: data.title,
      value: data.value,
      discount: data.discount,
      days_to_expire: data.days_to_expire,
      active: data.active,
      plan_ids: data.plan_ids.map(plan => plan.value),
    });
  };

  render() {
    const { data, errors, breadcrumbs } = this.state;
    const { create } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form
          data={data}
          errors={errors}
          saving={create.loading}
          onChange={this.handleChange}
          onSave={this.handleSave}
        />
      </Page>
    );
  }
}

const mapState = state => ({
  create: state.vouchers.create,
});

const mapActions = dispatch => bindActionCreators(VouchersActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(Create);
